module.exports = {"top3":["Hospital 30-day mortality","Children without all recommended vaccines","Uninsured children"],"bottom3":["Breast cancer deaths","Infant mortality","Employee insurance costs as a share of median income"],"most_improved":["Home health patients without improved mobility","Adults with any mental illness who did not receive treatment","Diabetic adults without an annual hemoglobin A1c test"],"most_declined":["Adults with any mental illness reporting unmet need","Children who did not receive needed mental health care","Drug poisoning deaths"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/DE.json
// module id = 248
// module chunks = 143196823979170 184088790168614